































import { defineComponent, ref, onMounted } from "@vue/composition-api";
import Iconfont from "./iconfont.vue";
import { swipe } from "@/utils/swipe";

/**
 * 基础抽屉
 */
export default defineComponent({
  components: { Iconfont },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    isFullScreen: {
      type: Boolean,
      default: false,
    },
    mini: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const handleToggle = () => {
      emit("update:isFullScreen", !props.isFullScreen);
    };

    const touchBarRef = ref(null);
    onMounted(() => {
      if (touchBarRef.value) {
        swipe(touchBarRef.value, {
          onSwipeUp: () => {
            emit("swipeup");
          },
          onSwipeDown: () => {
            emit("swipedown");
          },
        });
      }
    });

    return {
      touchBarRef,
      handleToggle,
    };
  },
});
